'use strict';

RelationsGridGridFactory.$inject = [
	'mx.SolutionBuilderAgent.ObjectsGrid',
	'mx.SolutionBuilderAgent.MultiSelectionTabService',
	'mx.SolutionBuilderAgent.MxGridHelperService',
	'mx.SolutionBuilderAgent.GridEnums',
];
export default function RelationsGridGridFactory(ObjectsGrid, multiSelectionTabService, gridHelperService, GridEnums) {
	const { DataDefinitionGridTypes } = GridEnums;

	class RelationsGrid extends ObjectsGrid {
		constructor() {
			super();
		}

		initProperties() {
			super.initProperties();

			let relation;

			Object.defineProperties(this, {
				/* external properties */
				data: {
					set: function (newValue) {
						if (newValue instanceof mx.SolutionBuilderAgent.Relation) {
							relation = newValue;
							relation.onChange(
								function (relation, fnName) {
									if (fnName !== 'changedInternal') {
										this.updateRequest();
										this.debouncedLoadItems();
									}
								}.bind(this)
							);

							this.updateRequest();
							this.debouncedLoadItems();
						}
					},
				},

				/* internal properties */
				relation: {
					get: function () {
						return relation;
					},
				},
				entityClassName: {
					get: function () {
						return relation?.relationsConfig.referenceTo;
					},
					set: function () {},
				},
			});
		}

		async initDataQuery() {
			return gridHelperService.initDQByDefinition(this.columnDefinition, this.entityClassName, DataDefinitionGridTypes.Relation);
		}

		updateRequest() {
			if (this.executor) {
				this.executor.updateRequestOptions({
					archived: this.parentView?.context?._archived || false,
					allowedTypes: this.allowedTypes,
					filter: this.filter,
					columnDefinition: this.columnDefinition,
					relation: this.relation,
				});
			}
		}

		findExistingEntities() {
			return multiSelectionTabService.open(
				{
					title: this.title,
					multiSelection: true,
					entityClassName: this.relation?.relationsConfig.referenceTo,
					allowedTypes: this.allowedTypes,
					filter: this.browseWhereClause,
					relation: this.relation,
					invertRelation: true,
					correctEntityFilter: this.browseWhereClause,
					excludedIDs: this.relation.addedRelations,
					objectIDs: this.relation.removedRelations,
					columnDefinition: this.columnDefinition,
					onlyTypedSelectSearch: this.onlyTypedSelectSearch,
					presetFields: this.getPresetFields(),
					createButtonHidden: this.createButtonInSelectionHidden,
				},
				this.parentView
			);
		}

		getPresetFields() {
			var presetFields = {};

			if (this.relation.fragmentId) {
				presetFields[this.relation.relationsConfig.referenceTo] = {};
				presetFields[this.relation.relationsConfig.referenceTo][this.relation.relationsConfig.attributeTo] = this.relation.fragmentId;
			}

			return presetFields;
		}

		afterEntitiesCreated(entities) {
			var fragmentIds = entities.map(function (entity) {
				return entity.Id;
			});

			var restored = [];
			var added = [];

			fragmentIds.forEach(function (fragmentId) {
				if (this.relation.removedRelations.indexOf(fragmentId) !== -1) {
					restored.push(fragmentId);
				} else if (this.relation.addedRelations.indexOf(fragmentId) === -1) {
					added.push(fragmentId);
				}
			}, this);

			this.relation.addedRelations.push.apply(this.relation.addedRelations, added);
			mx.components.Utils.removeItemsFromArray(this.relation.removedRelations, restored);
			this.relation.changedInternal();
		}

		removeEntities(entities) {
			var cleared = [], // added and then removed without saving
				removed = [];

			entities.forEach(function (entity) {
				var fragmentId = entity.Id;

				if (this.relation.addedRelations.indexOf(fragmentId) !== -1) {
					cleared.push(fragmentId);
				} else if (this.relation.removedRelations.indexOf(fragmentId) === -1) {
					removed.push(fragmentId);
				}

				mx.components.Utils.removeItemsFromArray(this.relation.addedRelations, cleared);
				this.relation.removedRelations.push.apply(this.relation.removedRelations, removed);
			}, this);

			this.relation.changedInternal();
			this.updateRequest();
			return this.loadItems();
		}

		isGridReady() {
			return Boolean(this.initialized && this.relation && (this.relation.fragmentId || this.relation.addedRelations.length || this.relation.removedRelations.length));
		}
	}

	return RelationsGrid;
}
